export default __webpack_public_path__ + "static/clipboard-hidden-327660b908d405cdef666312fff455e9.svg";